"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _GSemployeeRole = _interopRequireDefault(require("./GSemployeeRole"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.GSemployeeRole-container {\n  box-sizing: content-box;\n  margin: auto; }\n  .GSemployeeRole-container .info-container {\n    max-width: 100%;\n    width: 244px; }\n  .GSemployeeRole-container img {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1;\n    object-fit: cover; }\n  .GSemployeeRole-container .name {\n    margin-bottom: 0px;\n    width: auto;\n    max-width: 100%; }\n  .GSemployeeRole-container .lastname {\n    width: auto;\n    max-width: 100%; }\n  .GSemployeeRole-container .professional_function {\n    max-width: 204px; }\n  .GSemployeeRole-container .diploma_title {\n    margin-top: 2px; }\n  .GSemployeeRole-container .phone {\n    text-decoration: underline; }\n  @media (max-width: 66rem) {\n    .GSemployeeRole-container .info-container {\n      max-width: 100%;\n      width: 312px;\n      margin-left: 0px; } }\n  @media (max-width: 42rem) {\n    .GSemployeeRole-container .info-container {\n      max-width: 100%;\n      width: 288px;\n      margin-left: 0px; } }\n";
  const fileName = "GSemployeeRoleItem_GSemployeeRole";
  const element = document.querySelector("style[data-sass-component='GSemployeeRoleItem_GSemployeeRole']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getImage = async pictureURL => {
  const response = await fetch(pictureURL);
  const picture = await response.json();
  return picture;
};
const GSemployeeRoleItem = _ref => {
  let {
    item
  } = _ref;
  const data = item?.data;
  const [src, setSrc] = (0, _react.useState)();
  const [cachedValues, setCachedValues] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    async function fetchData() {
      setSrc(undefined);
      if (data?.image?.includes('?image_id')) {
        const key = data?.image;
        const cachedValue = cachedValues[key];
        if (cachedValue) {
          setSrc(cachedValue);
        } else {
          try {
            const image = await getImage(data?.image);
            setSrc(image);
            setCachedValues({
              ...cachedValues,
              [key]: image
            });
          } catch (error) {}
        }
      } else {
        setSrc(data?.image);
      }
    }
    fetchData();
  }, [data]);
  if (!data) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_GSemployeeRole.default, {
    firstname: data.firstname,
    lastname: data.lastname,
    professional_function: item.role || data.job,
    diploma_title: data.diploma_title,
    phone: data.phone,
    mobile: data.mobile,
    email: item.email,
    gender: data.gender === 'm' ? 'M' : 'F',
    picture: src,
    displayImage: !!src
  });
};
var _default = exports.default = GSemployeeRoleItem;